<template>
  <div>
    <div class="container">
      <div class="header">
        <img src="../assets/img/Web_Download_blurb.png" />
      </div>

      <!-- <div class="video">
        <iframe width="330" height="250" src="https://www.youtube.com/embed/3GwjfUFyY6M" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
      </div> -->

      <div class="download">
        <a href="https://itunes.apple.com/us/app/studio-1-treadmill-app/id1243064148?mt=8">
          <img src="../assets/img/Button_Download_On_App_Store.png" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Download',
  data () {
    return {}
  },
  methods: {
    done (type) {
      this.$emit('done')
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body,html {
  overflow: auto
}
.screen {
  background: url('../assets/img/vignette_gradient.png'), url('../assets/img/Background_Download.jpg');
  background-position: center center, 20% 0;
  background-size: cover, cover;
  background-repeat: repeat, no-repeat;
}

@media only screen and (min-width: 320px) and (max-width: 667px) and (-webkit-min-device-pixel-ratio: 2) {

  .screen {
    background: url('../assets/img/vignette_gradient.png'), url('../assets/img/Background_Download_s.jpg');
    background-position: center center, 70% 0;
    background-size: cover, cover;
    background-repeat: repeat, no-repeat;
  }

}

.container {}

.header {}

.download img {
  max-width: 50%;
  margin: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Download.vue